import { Component } from "react";
export class Route extends Component {
}
